import PropTypes from "prop-types";
import "./ChatMessageText.scss";
import "../VipMessage/VipMessage.scss";

const URL_PATTERN = /(\bhttps?:\/\/[^\s<]+|\bwww\.[^\s<]+)/gi;

const normalizeLinkHref = (url) =>
  url.startsWith("www.") ? `https://${url}` : url;

const parseMessageParts = (text) => {
  if (!text) return [{ type: "text", value: "" }];

  const parts = [];
  let lastIndex = 0;
  const regex = new RegExp(URL_PATTERN.source, URL_PATTERN.flags);
  let match = regex.exec(text);

  while (match) {
    if (match.index > lastIndex) {
      parts.push({ type: "text", value: text.slice(lastIndex, match.index) });
    }
    parts.push({ type: "link", value: match[0] });
    lastIndex = regex.lastIndex;
    match = regex.exec(text);
  }

  if (lastIndex < text.length) {
    parts.push({ type: "text", value: text.slice(lastIndex) });
  }

  return parts.length ? parts : [{ type: "text", value: text }];
};

const renderLine = (line, lineKey) =>
  parseMessageParts(line).map((part, index) =>
    part.type === "link" ? (
      <a
        key={`${lineKey}-link-${index}`}
        href={normalizeLinkHref(part.value)}
        target="_blank"
        rel="noopener noreferrer"
        className="chat-message-link"
        onClick={(e) => e.stopPropagation()}
      >
        {part.value}
      </a>
    ) : (
      <span key={`${lineKey}-text-${index}`} className="chat-message-text-part">
        {part.value}
      </span>
    )
  );

const ChatMessageText = ({ text, paragraphClassName = "chat-message-line" }) => {
  if (!text) return null;

  return text.split("\n").map((line, lineIndex) => (
    <p key={`line-${lineIndex}`} className={paragraphClassName}>
      {renderLine(line, lineIndex)}
    </p>
  ));
};

ChatMessageText.propTypes = {
  text: PropTypes.string,
  paragraphClassName: PropTypes.string,
};

export default ChatMessageText;
